
import { Pipe, PipeTransform } from '@angular/core';
import { ProjectViewSummary, ProjectViewVisibility } from '@jms/model';

@Pipe({
    name: 'viewIcon',
    standalone: true
})
export class ViewIconPipe implements PipeTransform {

    transform(item: ProjectViewSummary): string {

        if (item.system)
            return 'icomoon icomoon-wb-logo';

        switch (item.visibility) {
            case ProjectViewVisibility.Private:
                return 'fa-user';

            case ProjectViewVisibility.Shared:
                return 'fa-users';

            case ProjectViewVisibility.Public:
                return 'fa-globe';
        }
    }
}

